<template>
  <el-menu ref="menu" router>
    <MenuLogo class="logo"/>
    <el-submenu index="1">
      <template slot="title">
        <i class="fas el-icon-fa-th-list projects-icon"></i>
        <span>Projects</span>
      </template>
      <el-menu-item
        v-for="(project, index) in projects"
        v-bind:key="project.api_key"
        :index="'1-' + index"
        :route="{ name: 'project', params: { api_key: project.api_key }}"
      >{{ project.name }}</el-menu-item>
    </el-submenu>
    <div class="footer">
      <i class="fas el-icon-fa-user icon" />
      <span class="username">{{ this.$store.state.auth.username }}</span>
      <router-link :to="{ name: 'logout'}" class="logout">
        <el-button type="danger" icon="el-icon-close" circle size="mini" />
      </router-link>
    </div>
  </el-menu>
</template>

<script>

import axios from 'axios'

import MenuLogo from '@/components/MenuLogo.vue'

export default {
  components: {
    MenuLogo
  },
  data: function() {
    return {
      projects: null
    };
  },
  created() {
    axios({ url: "/api/v1/project/", method: "GET" })
      .then(resp => {
        this.projects = resp.data.results;
        this.$refs.menu.open("1");
      })
      .catch(err => {
        console.error(err);
      });
  }
};
</script>

<style scoped lang="sass">

.el-menu
  height: 100%
  background: $--menu-hover-background-color

.logo
  background: $--menu-background-color

.projects-icon
  margin-right: 10px

.footer
  position: absolute
  bottom: 0px
  width: 100%
  height: 70px
  @include flex($v: center)

  color: $--menu-text-color
  background-color: $--menu-item-background-color

  .icon
    padding-left: 20px

  .username
    padding-left: 5px

  .logout
    position: absolute
    right: 20px

</style>